export default __webpack_public_path__ + "static/hq2-24affdb1c43a68ac95eeb13298573c1d.jpg";